import { Button, Col, DatePicker, Flex, Form, Row, Typography } from 'antd';
import { TableRowSelection } from 'antd/es/table/interface';
import { useAppDispatch } from 'app/hooks';
import { IPermission } from 'common/types/commonTypes';

import { useState } from 'react';
import { useGetCreditLimitQuery } from '../api/creditLimitApi';
import { ICreditLimitList } from '../type/CreditLimit.interface';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';
import { setCommonModal } from 'common/slices/modalSlice';
import CreditLimitBulkUpdate from '../components/CreditLimitBulkUpdate';
import ClientTargetTable from '../components/ClientTargetTable';

type Props = {
  permission: IPermission | undefined;
};

const { Title } = Typography;

const CreditLimit = ({ permission }: Props) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const { data, isLoading } = useGetCreditLimitQuery();

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection: TableRowSelection<ICreditLimitList> = {
    selectedRowKeys,
    onChange: onSelectChange,
    columnWidth: 50,
  };

  const dataWithKey = data?.data?.map((item) => ({ key: item.client_id, ...item }));

  const hasSelected = selectedRowKeys.length > 0;

  const submit = () => {};

  return (
    <div>
      <Title level={3}>Client Credit Limit</Title>

      <Form onFinish={submit} form={form} layout='vertical' style={{ marginTop: 30 }}>
        <Flex hidden={!hasSelected} style={{ marginBottom: 20 }} justify='end'>
          <Button
            icon={<EditOutlined />}
            type='primary'
            onClick={() =>
              dispatch(
                setCommonModal({
                  content: (
                    <CreditLimitBulkUpdate
                      selectedRowKeys={selectedRowKeys}
                      setSelectedRowKeys={setSelectedRowKeys}
                    />
                  ),
                  show: true,
                  title: 'Bulk update data',
                  width: 400,
                })
              )
            }
          >
            Bulk update
          </Button>
        </Flex>
      </Form>

      <ClientTargetTable isLoading={isLoading} data={dataWithKey} rowSelection={rowSelection} />
    </div>
  );
};

export default CreditLimit;
